/* Parrot New Site — in-page catalog filters, ported from the canvas category pages.
   Each [data-pns-catalog] block holds a JSON config, chip groups and a grid of [data-pns-card] items.
   Config: { feed, pages, limit, count, brandCounts, childOf, parentUrl, sortDefault, filters } */
(function () {
  var CHIP = function (on, pad) {
    return 'min-height: 44px; padding: 0 ' + (pad || 16) + 'px; border: 2px solid #111111; cursor: pointer; font-family: Archivo, sans-serif; font-weight: 700; font-size: 14px; text-transform: uppercase; letter-spacing: 0.03em; background: ' + (on ? '#111111; color: #F1ECE2' : 'transparent; color: #111111');
  };
  var SMALL = function (on) {
    return 'min-height: 36px; padding: 0 12px; border: 1.5px solid ' + (on ? '#C2410C' : 'rgba(17,17,17,.35)') + '; cursor: pointer; font-family: Space Mono, monospace; font-size: 12px; text-transform: uppercase; background: ' + (on ? '#C2410C; color: #FFFFFF' : 'transparent; color: #111111');
  };
  /* When this theme is being previewed (not yet live), feed requests must name it,
     or Shopify answers them from the live theme, which has no pns-feed section. */
  var PREVIEW = (window.Shopify && Shopify.theme && Shopify.theme.role !== 'main' && Shopify.theme.id) ? '&preview_theme_id=' + Shopify.theme.id : '';

  function init(root) {
    var cfg = JSON.parse(root.querySelector('script[data-pns-config]').textContent);
    var grid = root.querySelector('[data-pns-grid]');
    var params = new URLSearchParams(window.location.search);
    var st = { cat: 'All', brand: 'All', thick: 'All', type: 'All', show: 'all', sort: cfg.sortDefault || 'new', limit: cfg.limit || 0 };
    var pmap = cfg.params || { cat: 'cat', brand: 'brand', thick: 'thick', type: 'type', show: 'show' };
    Object.keys(pmap).forEach(function (key) { if (params.get(pmap[key])) st[key] = params.get(pmap[key]); });
    if (cfg.childLabel && st.cat === 'All') st.cat = cfg.childLabel;
    var cards = [];
    var seq = 0;
    /* data-i keeps each card's position in the collection's own order (pages arrive in order),
       so "Newest" can follow the hand-sorted collection order (QuickBooks entry date, newest first). */
    function collect() {
      cards = Array.prototype.slice.call(grid.querySelectorAll('[data-pns-card]'));
      cards.forEach(function (c) { if (!c.hasAttribute('data-i')) c.setAttribute('data-i', seq++); });
    }
    collect();

    function paintChips() {
      root.querySelectorAll('[data-pns-chip]').forEach(function (b) {
        var f = b.getAttribute('data-pns-chip'), v = b.getAttribute('data-value');
        var on = (f === 'show' ? st.show : st[f]) === v;
        b.setAttribute('style', b.getAttribute('data-size') === 'small' ? SMALL(on) : CHIP(on, b.getAttribute('data-pad')));
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function buildBrands() {
      var box = root.querySelector('[data-pns-brands]'); if (!box) return;
      var counts = {};
      cards.forEach(function (c) { var v = c.getAttribute('data-v'); counts[v] = (counts[v] || 0) + 1; });
      var list = Object.keys(counts).sort(function (a, b) { return a.localeCompare(b, undefined, { sensitivity: 'base' }); });
      box.innerHTML = '';
      ['All'].concat(list).forEach(function (b) {
        var el = document.createElement('button');
        el.type = 'button';
        el.setAttribute('data-pns-chip', 'brand'); el.setAttribute('data-value', b); el.setAttribute('data-size', 'small');
        el.textContent = b === 'All' ? 'All brands' : (cfg.brandCounts ? b + ' (' + counts[b] + ')' : b);
        box.appendChild(el);
      });
      wire(box);
    }
    function match(c) {
      if (st.cat !== 'All' && (c.getAttribute('data-cats') || '').indexOf('|' + st.cat + '|') < 0) return false;
      if (st.brand !== 'All' && (c.getAttribute('data-v') || '').toLowerCase() !== st.brand.toLowerCase()) return false;
      if (st.thick !== 'All' && c.getAttribute('data-t') !== st.thick) return false;
      if (st.type !== 'All' && c.getAttribute('data-type') !== st.type) return false;
      if (st.show === 'colors' && c.getAttribute('data-nc') !== '1') return false;
      if (st.show === 'styles' && c.getAttribute('data-nc') === '1') return false;
      return true;
    }
    function idx(c) { return +(c.getAttribute('data-i') || 0); }
    function sortCards(list) {
      var s = st.sort;
      var by = {
        'new': function (a, b) {
          if (a.getAttribute('data-m') === '1' && b.getAttribute('data-m') === '1') return idx(a) - idx(b);
          return (b.getAttribute('data-d') || '').localeCompare(a.getAttribute('data-d') || '') || idx(a) - idx(b);
        },
        low: function (a, b) { return +a.getAttribute('data-p') - +b.getAttribute('data-p'); },
        high: function (a, b) { return +b.getAttribute('data-p') - +a.getAttribute('data-p'); },
        az: function (a, b) { return a.getAttribute('data-n').localeCompare(b.getAttribute('data-n')); }
      }[s];
      return by ? list.slice().sort(by) : list;
    }
    function render() {
      var list = sortCards(cards.filter(match));
      var shown = st.limit ? list.slice(0, st.limit) : list;
      cards.forEach(function (c) { c.style.display = 'none'; });
      shown.forEach(function (c) { c.style.display = 'flex'; grid.appendChild(c); });
      var more = root.querySelector('[data-pns-more]');
      if (more) {
        var left = list.length - shown.length;
        more.parentNode.style.display = left > 0 ? 'flex' : 'none';
        more.textContent = 'Show more · ' + left + ' left';
      }
      var empty = root.querySelector('[data-pns-empty]');
      if (empty) empty.style.display = list.length === 0 && !loading ? 'block' : 'none';
      var cnt = root.querySelector('[data-pns-count]');
      if (cnt) {
        if (loading && cfg.count === 'showing') cnt.textContent = '';
        else if (cfg.count === 'showing') cnt.textContent = 'Showing ' + shown.length + ' of ' + list.length + (cfg.unit ? ' ' + cfg.unit : (list.length === 1 ? ' product' : ' products'));
        else cnt.textContent = list.length + ' ' + (list.length === 1 ? (cfg.unitOne || 'product') : (cfg.unit || 'products'));
      }
      paintChips();
    }
    function wire(scope) {
      scope.querySelectorAll('[data-pns-chip]').forEach(function (b) {
        if (b._pns) return; b._pns = true;
        b.addEventListener('click', function () {
          var f = b.getAttribute('data-pns-chip'), v = b.getAttribute('data-value');
          if (f === 'cat' && cfg.childOf) {
            window.location.href = cfg.parentUrl + (v === 'All' ? '' : '?cat=' + encodeURIComponent(v)) + '#shop-grid';
            return;
          }
          st[f] = v; if (cfg.limit) st.limit = cfg.limit; render();
        });
      });
    }
    wire(root);
    var sel = root.querySelector('[data-pns-sort]');
    if (sel) { sel.value = st.sort; sel.addEventListener('change', function () { st.sort = sel.value; render(); }); }
    var moreBtn = root.querySelector('[data-pns-more]');
    if (moreBtn) moreBtn.addEventListener('click', function () { st.limit += cfg.limit; render(); });

    /* Fetch whenever there are pages the page itself didn't print (the surf wall prints none: firstFetch 1). */
    var first = cfg.firstFetch || 2;
    var loading = cfg.pages >= first;
    var loadingNote = root.querySelector('[data-pns-loading]');
    if (loadingNote) loadingNote.style.display = loading ? 'block' : 'none';
    buildBrands(); render();
    if (Object.keys(pmap).some(function (k) { return params.get(pmap[k]); })) {
      var anchor = document.getElementById(cfg.anchor || 'shop-grid'); if (anchor) anchor.scrollIntoView();
    }
    if (loading) {
      var pages = [];
      for (var i = first; i <= cfg.pages; i++) pages.push(i);
      Promise.all(pages.map(function (n) {
        var u = cfg.feed + (cfg.feed.indexOf('?') < 0 ? '?' : '&') + 'section_id=pns-feed&page=' + n + PREVIEW;
        return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      })).then(function (htmls) {
        htmls.forEach(function (h) {
          var d = document.createElement('div'); d.innerHTML = h;
          var feed = d.querySelector('[data-pns-feed]'); if (!feed) return;
          Array.prototype.slice.call(feed.querySelectorAll('[data-pns-card]')).forEach(function (c) { grid.appendChild(c); });
        });
        collect(); loading = false;
        if (loadingNote) loadingNote.style.display = 'none';
        buildBrands(); render();
      });
    }
  }
  function boot() { document.querySelectorAll('[data-pns-catalog]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* Volume finder (Surfboards) */
  window.pnsVolume = function (root) {
    var w = root.querySelector('[data-pns-weight]'), l = root.querySelector('[data-pns-level]'), out = root.querySelector('[data-pns-vol]');
    function calc() {
      var f = { beginner: [0.62, 0.75], intermediate: [0.40, 0.46], advanced: [0.35, 0.39], expert: [0.32, 0.35] }[l.value] || [0.40, 0.46];
      var kg = (Number(w.value) || 0) * 0.4536;
      out.textContent = kg > 0 ? Math.round(kg * f[0]) + '–' + Math.round(kg * f[1]) + 'L' : '—';
    }
    w.addEventListener('input', calc); w.addEventListener('change', calc); l.addEventListener('change', calc); calc();
  };
})();
